import "./App.css";
import Card from "./Card";

function App() {
  return (
    <div className="appPage">
      <Card />
    </div>
  );
}

export default App;
